export const iconFontAwesomeSpinnersSpinner = (
	<i className="fa-solid fa-spinner"></i>
);
